import { plugins } from "glamor";

// If document.body.id doesn't exist, make a random one.
// We use this id to increase the specificity of our CSS selectors.
document.body.id = document.body.id || `uw-glamor-${Math.random().toString().slice(15)}`;
plugins.add(getSpecificityPlugin(document.body.id));

// You can use the console to see that
// all glamor-generated selectors now include an id.

/**
 * Returns a glamor plugin function that uses a given id
 * @param {String} id - An id used to prefix selectors
 * @return {Function} - A glamor plugin function
 */
function getSpecificityPlugin(id) {
	/**
   * This prefixes glamor-generated CSS selectors with an id
   * to prevent global styles from overriding glamor styles.
   *
   * Learn more about glamor plugins:
   * https://github.com/threepointone/glamor/blob/master/docs/plugins.md
   */
	return function specificityPlugin({ selector, style }) {
		const prefixedSelector = selector
			.split(",")
			.map((sel) => `#${id} ${sel.trim()}`)
			.join(", ");
		return { selector: prefixedSelector, style };
	};
}
